<template>
  <v-dialog :value="showLoginManager" width="700" transition="dialog-top-transition" hide-overlay @input="setShowLoginManager" :persistent="mode === 'newPassword'">
    <TheResetPasswordForm v-if="mode === 'newPassword'" 
      @error="onError" 
      @passwordUpdated="passwordUpdated"
      @cancel="mode = null"
    />
    <TheForgotPasswordForm v-else-if="mode === 'forgotPassword'" 
      @error="onError" 
      @submitted="emailSubmitted" 
      @cancel="mode = null"
    />
    <TheLoginForm v-else 
      @error="onError" 
      @logged="logged" 
      @forgotPassword="mode = 'forgotPassword'"
    />
  </v-dialog>
</template>

<script>
import TheLoginForm from '@/components/Login/TheLoginForm'
import TheResetPasswordForm from '@/components/Login/TheResetPasswordForm'
import TheForgotPasswordForm from '@/components/Login/TheForgotPasswordForm'
import { ROUTE_MY_DASHBOARD } from '@/router/index'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'TheLoginManager',
  components: { TheLoginForm, TheResetPasswordForm, TheForgotPasswordForm },
  data: () => ({
    mode: null
  }),
  computed: {
    ...mapState('auth', [
      'showLoginManager'
    ]),
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler (value) {
        if (value.token) {
          this.mode = 'newPassword'
          this.setShowLoginManager(true)
        }
      }
    },
  },
  methods: {
    ...mapMutations('auth', [
      'setShowLoginManager'
    ]),
    passwordUpdated () {
      this.$store.dispatch('notify/success', this.$t('LoginPage.Success.updatedPassword'))
      this.mode = null
    },
    emailSubmitted () {
      this.$store.dispatch('notify/success', this.$t('LoginPage.Success.resetPasswordEmail'))
      this.mode = null
    },
    logged () {
      this.$router.push({ name: ROUTE_MY_DASHBOARD })
      this.setShowLoginManager(false)
    },
    onError (error) {
      this.$store.dispatch('notify/error', error)
    }
  },
}
</script>
